module.exports = __webpack_public_path__ + "img/bank.da8877e6.svg";